// extracted by mini-css-extract-plugin
export default {"box":"Loader_box__k+SI4"};